<template>
    <div class="border border-light-light rounded p-4 d-flex flex-column gap-3">
        <SearchInput v-model="searchString" inputClasses="form-control-solid"/>
        <div class="p-2 max-h-250px" style="overflow-y: scroll;">
            <div v-if="loading">
                <div class="spinner spinner-xs spinner-primary d-inline-block mr-5"/>
                {{ __('general.things.are_being_loaded', {things: things}) }}...
            </div>
            <RadioGroup v-else
                        :options="filteredEntries"
                        :value="value"
                        @input="newValue => $emit('input', newValue)"
            />
            <div v-if="searchString && filteredEntries === 0 && !loading">
                {{ __('general.things.none_found', {things: things}) }}
            </div>
        </div>
    </div>
</template>

<script>
import RadioGroup from "@components/Inputs/RadioGroup.vue";
import SearchInput from "@components/Form/SearchInput.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, SearchInput, RadioGroup},

    props: {
        options: {
            type: Object,
            required: true
        },
        value: {
            types: [Number, String, Object]
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        things: {
            type: String,
            default() {
                return __('general.items');
            }
        },
        loading: Boolean
    },

    data() {
        return {
            searchString: ''
        }
    },

    computed: {
        filteredEntries() {
            if (this.searchString.trim() === '') {
                return this.options;
            }

            let filtered = {};
            let search = this.searchString.toLowerCase();

            for (let key in this.options) {
                if (key.toLowerCase().includes(search)) {
                    filtered[key] = this.options[key];
                }
            }

            return filtered;
        }
    }
}
</script>
